import { render, staticRenderFns } from "./comIndex.vue?vue&type=template&id=35e4b8f2&"
import script from "./comIndex.vue?vue&type=script&lang=js&"
export * from "./comIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports